export class Pool {
  constructor(factory) {
    this.pool = [];
    this.factory = factory;
    this.created = 0;
    this.givenInstances = new Set();
  }

  factory() {
    return {};
  }

  getInstance() {
    if (this.pool.length) {
      const a = this.pool.pop();
      a.show();
      this.givenInstances.add(a);
      return a;
    }
    // eslint-disable-next-line no-plusplus
    this.created++;
    const a = this.factory(this.created);
    this.givenInstances.add(a);
    return a;
  }

  storeInstance(inst) {
    inst.hide();
    this.pool.push(inst);
    this.givenInstances.delete(inst);
  }

  storeAllInstances() {
    this.givenInstances.forEach((a) => {
      a.hide();
      this.pool.push(a);
    });
    this.givenInstances.clear();
  }
}
